<template>
  <form @submit.prevent="confirm()">
    <div>
      <div>
        <div class="form-group">
          <label for="cantonnier">Cantonnier</label>
          <select v-model="selectedCantonnier" class="form-control" id="cantonnier" required :disabled="demande.statusDemande && demande.statusDemande !== 'En attente de réponse' && demande.statusDemande !== 'Acceptée'">
            <option v-for="cantonnier in cantonniers.data" v-bind:value="cantonnier" v-bind:item="cantonnier" v-bind:key="cantonnier.id">
              {{ cantonnier.nom }}, {{ cantonnier.prenom }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="cantonnier">Priorité</label>
          <select v-model="selectedPriorite" class="form-control" id="priorite" required :disabled="demande.statusDemande && demande.statusDemande !== 'En attente de réponse' && demande.statusDemande !== 'Acceptée'">
            <option v-for="priorite in this.$store.state.priorites" v-bind:value="priorite" v-bind:item="priorite" v-bind:key="priorite.id">
              {{ priorite.name }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="nom">Objet de la demande</label>
          <textarea type="text" class="form-control" id="nom" v-model="demande.objet" required :disabled="demande.statusDemande && demande.statusDemande !== 'En attente de réponse' && demande.statusDemande !== 'Acceptée'">
          </textarea>
        </div>

        <div class="form-group">
          <label for="coords">Coordonnées</label>
        </div>

        <div class="form-group map-wrapper">
          <div class="map-container">
            <input id="pac-input" class="controls" type="text" placeholder="Barre de recherche" autocomplete="on">
            <gmap-map
              id="gMap"
              ref="gMap"
              :center="center"
              :zoom="15"
              map-type-id="roadmap"
              style="width:100%;  height: 400px;">

              <gmap-marker
                ref="myMarkers"
                :key="index"
                v-for="(m, index) in markers"
                :position="m.position"
                @click="center=m.position"
              ></gmap-marker>
            </gmap-map>
          </div>
        </div>

      </div>

      <div class="buttons">
        <button class="btn btn-primary" :disabled="demande.statusDemande && demande.statusDemande !== 'En attente de réponse' && demande.statusDemande !== 'Acceptée'">Confirmer</button>
        <div class="btn btn-default" v-on:click="$emit('close')">
          Annuler
        </div>
      </div>
    </div>
  </form>
</template>
<script>
/* eslint-disable */
import _ from 'lodash'
import { mapState } from 'vuex'
import * as demandeStatut from './../../../utils/demandeStatut'
import * as VueGoogleMaps from 'vue2-google-maps'
import moment from 'moment'

export default {
  computed: {
    ...mapState([
      // 'cantonniers',
      'map',
      // 'maitrise',
      'currentUser',
      'currentVille',
      'cantonniers',
    ]),
    mapStyle: function () {
      const h = document.body.clientHeight - 80
      return 'width: 100%; height: ' + h + 'px'
    },
    center: function () {
      return {lat: this.$store.state.currentVille.coords.lat, lng: this.$store.state.currentVille.coords.lon}
    },
  },
  props: [
    'updateDemande',
  ],
  data: function () {
    return {
      demande: this.updateDemande ? _.cloneDeep(this.updateDemande) : {},
      // currentMaitriseArrondissement: this.$store.state.currentMaitriseArrondissement,
      picked: 'non',
      selectedCantonnier: '',
      selectedPriorite: null,
      mapLoaded: false,
      position: this.updateDemande ? {'lat': this.updateDemande.lat, 'lon': this.updateDemande.lon} : '',
      currentPlace: null,
      markers: [],
      place: null,
    }
  },
  methods: {
    confirm: function () {
      if (this.updateDemande) {

        this.demande.actif = true
        this.demande.cantonnier_id = this.selectedCantonnier.id
        if (this.position && this.position.lat && this.position.lat !== 0 && this.position.lon && this.position.lon !== 0) {
          this.demande.lat = this.position.lat
          this.demande.lon = this.position.lon
        }
        this.demande.priority = this.selectedPriorite.id
        console.log('confirmed demande ====',this.demande)
        this.$store.dispatch('updateDemande',this.demande)
        //this.$store.dispatch('updateDemande', this.demande)
        //this.$store.dispatch('updateNotification', {demandeId: this.demande.meta.id, cantonnierId: this.demande.cantonnier.id})
      }
      else
      {
        this.demande.cantonnier_id = this.selectedCantonnier.id
        this.demande.statusDemande = demandeStatut.STATUT_EN_ATTENTE
        if (this.position && this.position.lat && this.position.lat !== 0 && this.position.lon && this.position.lon !== 0) {
          this.demande.lat = this.position.lat
          this.demande.lon = this.position.lon
        }
        this.demande.priority = this.selectedPriorite.id
        console.log('confirmed demande ====',this.demande)
        this.$store.dispatch('createDemande', this.demande)
      }
      this.$emit('close')
    },
  },
  mounted: function () {
    console.log("mount ? ",this.demande)
    console.log("demande to be updated =======",this.demande)
    this.$store.dispatch('fetchCantonniersByVilleId')
    let store = this
    VueGoogleMaps.loaded.then(() => {
      this.mapLoaded = true
      let markerAdded = false
      let gMap = new google.maps.Map(document.getElementById('gMap'), {
        zoom: 15,
        center: {lat: this.$store.state.currentVille.coords.lat, lng: this.$store.state.currentVille.coords.lon}
      })
      if (store.position) {
        let pos = new google.maps.LatLng({lat: store.position.lat, lng: store.position.lon})
        var marker = new google.maps.Marker({
          position: pos,
          map: gMap,
          draggable: true,
        })
        if (this.updateDemande && this.updateDemande.statusDemande === 'En attente de réponse') {
          google.maps.event.addListener(marker, 'dragend', function(ev){
            store.position = { 'lat': ev.latLng.lat(), 'lon': ev.latLng.lng()}
          })
        }
      }

      var searchBox = new google.maps.places.SearchBox(document.getElementById('pac-input'));
      gMap.controls[google.maps.ControlPosition.TOP_CENTER].push(document.getElementById('pac-input'));
      google.maps.event.addListener(searchBox, 'places_changed', function() {

        searchBox.set('gMap', null);
        var places = searchBox.getPlaces();
        var bounds = new google.maps.LatLngBounds();
        var i, place;
        for (i = 0; place = places[i]; i++) {
          (function(place) {
            var marker = new google.maps.Marker({
              position: place.geometry.location
            });
            marker.bindTo('gMap', searchBox, 'gMap');
            google.maps.event.addListener(marker, 'map_changed', function() {
              if (!this.getMap()) {
                this.unbindAll();
              }
            });
            bounds.extend(place.geometry.location);
          }(place));
        }
        gMap.fitBounds(bounds);
        searchBox.set('gMap', gMap);
        gMap.setZoom(Math.min(gMap.getZoom(),18));
      });

      if (!this.updateDemande || this.updateDemande.statusDemande === 'En attente de réponse') {
        gMap.addListener('dblclick', function(e) {
          if (!markerAdded) {
            var marker = new google.maps.Marker({
              position: e.latLng,
              map: gMap,
              visible: true,
              draggable: true,
            })
            store.position = { 'lat': marker.getPosition().lat(), 'lon': marker.getPosition().lng()}
            markerAdded = true
            google.maps.event.addListener(marker, 'dragend', function(ev){
              store.position = { 'lat': ev.latLng.lat(), 'lon': ev.latLng.lng()}
            })
          }
        })
      }
    })
    if (this.updateDemande) {
      this.selectedCantonnier = this.cantonniers.allData.find((canto) => {
        return this.updateDemande.cantonnier_id === canto.id;
      })
      this.selectedPriorite = this.updateDemande.priority
      if (this.updateDemande.priority == "1"){
        this.selectedPriorite = this.$store.state.priorites[0]
      }else if(this.updateDemande.priority == "2"){
        this.selectedPriorite = this.$store.state.priorites[1]
      }else {
        this.selectedPriorite = this.$store.state.priorites[2]
      }
    }
    if (this.selectedCantonnier) {
      console.log("Selected cantonnier found:", this.selectedCantonnier);
    } else {
      console.log("Selected cantonnier not found.");
    }
  },
}
</script>

<style lang="scss">
   textarea {
     resize: none;
     height: 140px !important;
   }
  .map-wrapper {
    position: relative;
    width: 100%;
    height: 400px;

    .map-container {
        height: 100%;
    }
  }

</style>



// WEBPACK FOOTER //
// DemandeForm.vue?97a6134a